module.exports = __webpack_public_path__ + "static/media/image_43.5a1c36cf.png";